export default __webpack_public_path__ + "locales/pt/EmptyView.json?hash=bb315e69044dcd50c70a0b1458955f8a";